import * as R from 'ramda'
import { LocalFind, LocalInsert } from '@weblite/persist'
import { synchronizePersist } from '$func/webApis'
import { isLoggedIn } from '$logic/auth'

const key = 'lastSyncVersion'
const reasons = ['messageRace']
const lastReason = R.last(reasons)

let checkForSynchronizePersistDisabled = false

export function disableCheckForSynchronizePersist() {
  checkForSynchronizePersistDisabled = true
}

export const checkForSynchronizePersistToResolveRace = () => {
  if (!isLoggedIn() || checkForSynchronizePersistDisabled) {
    LocalInsert(key, lastReason)
    return
  }
  const lastSyncedReason = LocalFind(key)
  if (lastSyncedReason !== lastReason) {
    LocalInsert(key, lastReason)
    synchronizePersist()
  }
}
